document.addEventListener('DOMContentLoaded', function() {
  const drawers = document.querySelectorAll('[id^="HeaderDrawer-"]');
  const detailsElements = document.querySelectorAll('details');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const delay = entry.target.getBoundingClientRect().top * 0.5; // Aumenta ulteriormente il fattore di moltiplicazione
        setTimeout(() => {
          entry.target.style.transition = 'opacity 0.5s ease';
          entry.target.style.opacity = '1';
        }, delay);
        observer.unobserve(entry.target); // Smette di osservare l'elemento una volta animato
      }
    });
  }, { threshold: 0.1 }); // Inizia l'animazione quando il 10% dell'elemento è visibile

  const mutationObserver = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'open') {
        const details = mutation.target;
        if (details.open) {
          drawers.forEach(drawer => {
            drawer.style.opacity = '0'; // Reset opacità
            drawer.style.transition = 'none'; // Rimuove qualsiasi transizione
            observer.observe(drawer); // Riapplica l'osservatore
          });
        }
      }
    });
  });

  detailsElements.forEach(details => {
    mutationObserver.observe(details, { attributes: true });
  });

  // Aggiungi un listener per il pulsante del menu
  const menuButton = document.querySelector('.header__icon--menu');
  if (menuButton) {
    menuButton.addEventListener('click', () => {
      drawers.forEach(drawer => {
        drawer.style.opacity = '0'; // Reset opacità
        drawer.style.transition = 'none'; // Rimuove qualsiasi transizione
        observer.observe(drawer); // Riapplica l'osservatore
      });
    });
  }
});